import { onLocalFilesSelected } from '../actions/onFilesSelected';
import { CreateAttachmentHandler } from '../types/CreateAttachmentHandler';
import { observer } from 'mobx-react';
import { FilePickerAction, FileSelectionFilter } from 'owa-attachment-filepicker';
import { LocalComputerFilePicker, ILocalComputerFilePicker } from 'owa-filepicker';
import * as React from 'react';

export interface AttachmentLocalComputerFilePickerProps {
    fileSelectionFilter?: FileSelectionFilter;
    createAttachmentHandler: CreateAttachmentHandler;
    action: FilePickerAction;
}

export interface IAttachmentLocalComputerFilePicker {
    click(): void;
}

@observer
export default class AttachmentLocalComputerFilePicker
    extends React.Component<AttachmentLocalComputerFilePickerProps, {}>
    implements IAttachmentLocalComputerFilePicker {
    private localComputerFilePicker: React.RefObject<ILocalComputerFilePicker> = React.createRef();

    render() {
        return (
            <LocalComputerFilePicker
                ref={this.localComputerFilePicker}
                onFilesSelected={this.onFilesSelected}
                fileSelectionFilter={this.props.fileSelectionFilter}
            />
        );
    }

    public click() {
        this.localComputerFilePicker.current && this.localComputerFilePicker.current.click();
    }

    private onFilesSelected = (files: File[]) => {
        const { action, createAttachmentHandler } = this.props;

        const isInline = action === FilePickerAction.Insert;
        const shouldShare = action === FilePickerAction.Share;
        onLocalFilesSelected(createAttachmentHandler, files, isInline, shouldShare);
    };
}
